import React, { useState } from 'react';
import styles from './styles.module.scss';

interface CerConsentSlideProps {
  onNext: () => void;
}

const CerConsentSlide: React.FC<CerConsentSlideProps> = ({ onNext }) => {
  const [statuto, setStatuto] = useState(false);
  const [cerMarketing, setCerMarketing] = useState(false);
  const [thirdMarketing, setThirdMarketing] = useState(false);
  const [thirdProfiling, setThirdProfiling] = useState(false);

  const canProceed = statuto && cerMarketing;

  return (
    <div className={styles.cerConsentSlide}>
      <h3 className={styles.title}>Consensi per l'adesione a CER Enpal</h3>

      <p className={styles.intro}>
        Ti invitiamo a prendere visione dello{' '}
        <a
          href="https://drive.google.com/file/d/1oM1Tvym0Th3KLiqG3pl5_2O9KVU7kUE2/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Statuto
        </a>{' '}
        e del{' '}
        <a
          href="https://drive.google.com/file/d/1RnmakOL5dNNL_LZFGsDADV8FwABP44ee/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Regolamento
        </a>{' '}
        di CER Enpal.
      </p>

      <div className={styles.checkboxGroup}>
        <label className={`${styles.checkboxItem} ${styles.required}`}>
          <input
            type="checkbox"
            checked={statuto}
            onChange={(e) => setStatuto(e.target.checked)}
          />
          <span>
            Confermo di aver preso visione dello Statuto e del Regolamento interno, e del mandato
            conferito al referente per la presentazione dell'istanza di accesso al servizio di
            incentivazione dell'energia.{' '}
            <strong className={styles.requiredTag}>(obbligatorio)</strong>
          </span>
        </label>

        <label className={`${styles.checkboxItem} ${styles.required}`}>
          <input
            type="checkbox"
            checked={cerMarketing}
            onChange={(e) => setCerMarketing(e.target.checked)}
          />
          <span>
            Acconsento di ricevere comunicazioni promozionali, newsletter, questionari e materiale
            pubblicitario sui servizi di Comunità Energetica Enpal. Acconsento inoltre l'analisi
            automatizzata delle mie abitudini e preferenze per ricevere proposte personalizzate da
            parte di Comunità Energetica Enpal.{' '}
            <strong className={styles.requiredTag}>(obbligatorio)</strong>
          </span>
        </label>

        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            checked={thirdMarketing}
            onChange={(e) => setThirdMarketing(e.target.checked)}
          />
          <span>
            Acconsento al trasferimento dei miei dati a partner terzi per finalità di marketing.{' '}
            <span className={styles.optionalTag}>(facoltativo)</span>
          </span>
        </label>

        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            checked={thirdProfiling}
            onChange={(e) => setThirdProfiling(e.target.checked)}
          />
          <span>
            Acconsento al trasferimento dei miei dati a partner terzi per finalità di profilazione.{' '}
            <span className={styles.optionalTag}>(facoltativo)</span>
          </span>
        </label>
      </div>

      <button
        type="button"
        className={styles.btnProceed}
        onClick={onNext}
        disabled={!canProceed}
      >
        Procedi
      </button>
    </div>
  );
};

export default CerConsentSlide;
